import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AvatarEditor } from '../../avatars/avatarEditor/avatarEditor';
import { useAppSelector } from '../../redux/store';
import { SelfPanelDefaultContents } from './selfPanelDefaultContents';
export const SelfPanelContents = () => {
    const isAvatarEditorOpen = useAppSelector((state) => state.selfAvatar.isAvatarEditorOpen);
    const isLoadingSelfInfo = useAppSelector((state) => state.selfData.isLoadingSelfInfo);
    if (isLoadingSelfInfo) {
        return _jsx(_Fragment, { children: "Loading..." });
    }
    if (isAvatarEditorOpen) {
        return _jsx(AvatarEditor, {});
    }
    else {
        return _jsx(SelfPanelDefaultContents, {});
    }
};
